import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-shield',
  templateUrl: './profile-tab-shield.component.html',
  styleUrls: ['./profile-tab-shield.component.scss']
})
export class ProfileTabShieldComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
